module.exports = __webpack_public_path__ + "static/dashboard.c9cffd8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/dashboard.png
// module id = ./src/pages/index/dashboard.png
// module chunks = 2345137460201621000 17463659626562118000